// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#load-session {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  height: 100vh;
  padding: 50px;
  box-sizing: border-box;
}

#load-session .loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100vh;
}

#load-session .loading h1 {
  font-family: var(--font);
  font-size: 2.5rem;
  margin-bottom: 1rem;
  text-align: center;
  color: var(--dark-blue);
}

#load-session .clients h2 {
  font-family: var(--font);
  font-size: 2rem;
  margin-bottom: 1rem;
  text-align: center;
  color: var(--dark-blue);
}

#load-session .clients ul {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  gap: 20px;
  box-sizing: border-box;
  list-style: none;
  padding: 0;
}

#load-session .clients li {
  display: flex;
  width: 100%;
}

#load-session .clients li button {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 40px;
  gap: 10px;
  border-radius: 4px;
  border: 3px solid var(--dark-blue);
  font: var(--font);
  font-size: 1.2rem;
  font-weight: 600;
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/routes/LoadSession/LoadSession.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;EAC3B,WAAW;EACX,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,sBAAsB;EACtB,uBAAuB;EACvB,WAAW;EACX,SAAS;EACT,sBAAsB;EACtB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,kCAAkC;EAClC,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB","sourcesContent":["#load-session {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start;\n  width: 100%;\n  height: 100vh;\n  padding: 50px;\n  box-sizing: border-box;\n}\n\n#load-session .loading {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100vh;\n}\n\n#load-session .loading h1 {\n  font-family: var(--font);\n  font-size: 2.5rem;\n  margin-bottom: 1rem;\n  text-align: center;\n  color: var(--dark-blue);\n}\n\n#load-session .clients h2 {\n  font-family: var(--font);\n  font-size: 2rem;\n  margin-bottom: 1rem;\n  text-align: center;\n  color: var(--dark-blue);\n}\n\n#load-session .clients ul {\n  display: flex;\n  justify-content: flex-start;\n  flex-direction: column;\n  align-items: flex-start;\n  width: 100%;\n  gap: 20px;\n  box-sizing: border-box;\n  list-style: none;\n  padding: 0;\n}\n\n#load-session .clients li {\n  display: flex;\n  width: 100%;\n}\n\n#load-session .clients li button {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: 40px;\n  gap: 10px;\n  border-radius: 4px;\n  border: 3px solid var(--dark-blue);\n  font: var(--font);\n  font-size: 1.2rem;\n  font-weight: 600;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
